module.exports = __webpack_public_path__ + "assets/img/staticAnalysis.a7391476.svg";